// Note since theme package of atlaskit is deprecated and pulls in styled-components that we want to get rid of,
// we only pull in the stuff we need.

export const gridSize = () => 8;
export const fontSize = () => 14;
